import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './NavigationLink.scss';
import classNames from 'classnames';

import {Link} from 'react-router';

export default class NavigationLink extends Component {
    static propTypes = {
        active: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool
        ]),
        label: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        counter: PropTypes.number,
        homePageOpened: PropTypes.bool,
    };

    static defaultProps = {
        active: false,
        counter: 0,
        homePageOpened: false,
    }

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        const {label, to, counter, homePageOpened, isExternal} = this.props;

        const className = classNames(styles.link, {
            [styles.active]: this.isActive()
        });

        return isExternal ? (
            <a href={to} className={className}>
                <span className={classNames(styles.label, {[styles.homePageOpened]: homePageOpened})}>{label}</span>

                <div className={styles.underline}></div>
                {Boolean(counter) && <div className={styles.counter}> {counter}</div>}
            </a>
        ) : (
            <Link to={to} className={className}>
                <span className={classNames(styles.label, {[styles.homePageOpened]: homePageOpened})}>{label}</span>

                <div className={styles.underline}></div>
                {Boolean(counter) && <div className={styles.counter}> {counter}</div>}
            </Link>
        );
    }

    isActive() {
        const {to, active} = this.props;
        if (typeof active === 'boolean')
            return active;

        return to === this.context.router.location.pathname;
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/NavigationLink.js